import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialModal } from 'components/layout'
import { AssessorReject } from 'containers/forms/dashboard'

export default class StopAssessingSectionModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
    colorClass: PropTypes.string,
    onConfirm: PropTypes.func
  }

  render() {
    const { modalId, colorClass } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title="Stop assessing section"
        colorClass={colorClass}
        titleKey="moduleTitle.stop_assessing_section"
      >
        <MaterialModal.Content>
          <AssessorReject
            colorClass={colorClass}
            onConfirm={this.props.onConfirm}
          />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
